import swal from "sweetalert2";

export default /*@ngInject*/ function (ViewProductImportPageService, helperService, connectionsDataService) {
    var vm = this;

    vm.ViewProductImportPageService = ViewProductImportPageService;
    vm.getImportStatusClass = getImportStatusClass;
    vm.deleteProduct = deleteProduct;

    function getImportStatusClass(status) {
        const classes = {
            "Completed": "toast-success",
            "InProgress": "toast-loading",
            "Error": "toast-error",
            "Skipped": "toast-warning"
        }

        return classes[status];
    }

    async function deleteProduct() {
        try {
            await swal(helperService.areYouSureParams(
                'Delete Product',
                `Are you sure you want to delete ${vm.product.Name}? This action cannot be undone. All data associated with this product will be permanently removed.`,
                'Delete'
            ));
        } catch {
            return;
        }

        await connectionsDataService.deleteProduct(vm.product.ID);
        // Refresh and success notification are handled via SignalR DeleteProduct event in the parent.
    }
}
